// extracted by mini-css-extract-plugin
export var fadeIn = "_m1-1";
export var modalContent = "_m1-3";
export var overlay = "_m1-0";
export var popoverContent = "_m1-2";
export var results = "_m1-5";
export var searchInputWrapper = "_m1-4";